import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const PendingReview = new StatusEnumItem({
  id: '44c97685-cc34-4c36-a599-125f438c4c39',
  name: 'Pending Review',
  description:
    'The Identified Field Issue has been imported and is awaiting review',
  priority: 0,
})

const Closed = new StatusEnumItem({
  id: 'f84a95e1-cae5-453b-91a4-f9c0428d28f3',
  name: 'Closed',
  description:
    'The Identified Field Issue has been reviewed. A new Issue may have been created from it',
  priority: 1,
})

export type IFIStatusItem = typeof PendingReview | typeof Closed

class IFIStatusEnum extends StatusEnum<
  'IFIStatus',
  IFIStatusItem,
  IFIStatusItem['name'],
  IFIStatusItem['id'],
  IFIStatusItem['priority']
> {
  readonly typename = 'IFIStatus'
  get values() {
    return [this.PendingReview, this.Closed]
  }
  readonly PendingReview = PendingReview
  readonly Closed = Closed
}

export const IFIStatus = new IFIStatusEnum()
